import { Log, Geotag } from '../models';

const getHour = time => Math.floor(time / 100);

/**
 *
 * @param {Log} log
 * @param {Geotag[]} geotags
 * @param {number} isOffset
 */
function loadGeotagLogs(log, geotags, offset) {
  const res = {
    BIO1: log?.BIO1 || 0,
    BIO2: log?.BIO2 || 0,
    BIO3: log?.BIO3 || 0,
    BIO4: log?.BIO4 || 0,
    BIO5: log?.BIO5 || 0,
    BIO6: log?.BIO6 || 0,
    BIO7: log?.BIO7 || 0,
    BIO8: log?.BIO8 || 0,
    BIO9: log?.BIO9 || 0,
    BIO10: log?.BIO10 || 0,
    BIO11: log?.BIO11 || 0,
    BIO12: log?.BIO12 || 0
  };

  for (const geotag of geotags) {
    let temp = 0;

    const time = geotag.ixDatetime % 10000;

    if (Object.keys(res).some(key => res[key] === time)) continue;

    const isOffset = Math.floor(time / 100) < offset;

    let i = 1;

    while (i <= 12) {
      const bioKey = 'BIO' + i;

      // if end was reached and not yet added
      if (res[bioKey] === 0) {
        res[bioKey] = time;
        break;
      }

      if (isOffset && time < res[bioKey] && getHour(res[bioKey]) < offset) {
        temp = res[bioKey];
        res[bioKey] = time;
        i++;
        break;
      } else if (!isOffset && time < res[bioKey]) {
        temp = res[bioKey];
        res[bioKey] = time;
        i++;
        break;
      }

      i++;
    }

    while (temp !== 0 && i <= 12) {
      let swap = res['BIO' + i];
      res['BIO' + i] = temp;
      temp = swap;
      i++;
    }
  }

  return res;
}

export default loadGeotagLogs;
